import { Component, Input } from '@angular/core';

export type AvatarSize = 'sm' | 'md' | 'lg';
export type AvatarColor = 'teal' | 'green' | 'blue' | 'orange' | 'pink' | 'purple' | 'mint' | 'grey';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  standalone: false
})
export class AvatarComponent {
  @Input() size: AvatarSize = 'md';
  @Input() color: AvatarColor = 'grey';
}
